module.exports = __webpack_public_path__ + "static/media/info.a100106f.svg";